// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"99474bdb","796":"09712124"}[chunkId] + ".chunk.js";
};